import React, {Component} from "react";
import {withRouter} from "react-router";
import {Elastic, Flex, Mycard} from "../ui";
import SimpleReactValidator from "simple-react-validator";
import CustomizedSnackbars from "../Helpers/Alerts";
import {toast} from "react-toastify";
import {FooterL, Mycheck} from "./helpers";
import FacturaComp from "./facturaComp";
import {Modal} from "../ServiciosMaestros/componentGeneral";
import CurrencyFormat from "react-currency-format";

toast.configure({
    autoClose: 5000,
    draggable: true,
});


let ruta = {};

class ListafacturasOnline extends Component {

    constructor(props){
        super(props)
        this.state = {
            total: 0,
            totalPagar: 0,
            facturas: [],
            facturasOriginal:[],
            loading: false,
            checks:[],
            checksOtroValor:[],
            checksValor1:[],
            checksValor2:[],
            checksValor3:[],
            valuesOtroValor:[],
            allCheck:false,
            agruparFacturas:false,
            paginacion:{},
            pagina:1,
            hasMoreItems:true,
            moneda:"COP",
            tituloFactura:"",
            abonarFactura:false,
            error: '',
            showMessage:{
                open: false,
                type: 'info',
                isDelay: false,
                message : ''
            },
            showModal:{
                activo: false,
                data: []
            },
            opcionesRecaudo: null,
            cambiarPantalla:false,
            procesando:true,
            minimos:[],
            maximos:[],
            invalidos:[]
        }
        this.closedAlert = this.closedAlert.bind(this);
        this.showModal = this.showModal.bind(this);
        this.clickCheckValor1 = this.clickCheckValor1.bind(this);
        this.clickCheckValor2 = this.clickCheckValor2.bind(this);
        this.clickCheckValor3 = this.clickCheckValor3.bind(this);
        this.onChangeOtroValor = this.onChangeOtroValor.bind(this);
        this.FormatoCampo = this.FormatoCampo.bind(this);
        this.getTipoMoneda = this.getTipoMoneda.bind(this);


        this.pagar = this.pagar.bind(this);

        this.validator = new SimpleReactValidator({
            validators: {
                otroValor:{
                    message: ':attribute',
                    rule: (val) => {
                    },
                }
            }

        })
    }

    componentWillMount() {
        ruta = JSON.parse(sessionStorage.getItem("rutas"));

    }

    valorTotal() {
        let checks = [...this.state.checks];
        let checksOtroValor = [...this.state.checksOtroValor];
        let checksValor1 = [...this.state.checksValor1];
        let checksValor2 = [...this.state.checksValor2];
        let checksValor3 = [...this.state.checksValor3];
        let valuesOtroValor = [...this.state.valuesOtroValor];
        let facturas = [...this.state.facturas];
        let totalPagar = 0;
        let opcionesRecaudo = this.state.opcionesRecadudo || JSON.parse(sessionStorage.getItem('opcionesRecaudo'))
        // console.log("OPCIONES:::",opcionesRecaudo)
        //Validar multiples valores para pago
        if (opcionesRecaudo != "" && opcionesRecaudo && ((opcionesRecaudo.multiplesValoresPago && opcionesRecaudo.multiplesValoresPago.activo) || (opcionesRecaudo.agruparFacturas && opcionesRecaudo.agruparFacturas.activo))) {
            totalPagar = 0
            checks.map((checked, key) => {
                if (checked) {
                    if (checksOtroValor[key]) {
                        totalPagar += valuesOtroValor[key];
                    } else {
                        let factura = facturas[key]
                        // console.log('FACTURA:::', factura,checked)
                        if (checksValor1[key] && factura) {
                            totalPagar += factura.filter(f => f.entidad === 'total')[0].valor2
                        } else if (checksValor2[key] && factura) {
                            totalPagar += factura.filter(f => f.entidad === 'segundoTotal')[0].valor2
                        } else if (checksValor3[key] && factura) {
                            totalPagar += factura.filter(f => f.entidad === 'tercerTotal')[0].valor2
                        }
                    }

                }
                return '';
            })

        }
        this.setState({
            totalPagar
        })
    }

    cambiarPantalla() {
        if (this.state.opcionesRecaudo && this.state.opcionesRecaudo.agruparFacturas.activo) {
            this.setState({
                cambiarPantalla: true
            })
        }
    }

    minMax(){
        let facturas = [...this.state.facturas]
        let facturasOriginal = [...this.state.facturasOriginal]
        let modificarValor = this.state.opcionesRecaudo.modificarValorPagar
        let configCampos = JSON.parse(sessionStorage.getItem("configCampos"));

        let optionValue = null;
        if(!!modificarValor.value){
            optionValue = modificarValor.value;
        }

        let aux = 0;
        facturas[0].map((fac, key) => {
            if (fac.entidad === "total") {
                aux++;
            }
            if (fac.entidad === "segundoTotal") {

                aux++;
            }
            if (fac.entidad === "tercerTotal") {

                aux++;
            }
        });

        let min=[];
        let max=[];
        if (modificarValor.activo) {
            facturas.map((fact,key)=>{
                let valores = [];
                facturas[key].filter((infoFac) => {
                    if (infoFac.entidad === "total" || infoFac.entidad === "segundoTotal" || infoFac.entidad === "tercerTotal") {
                        valores.push(infoFac.valor2);
                    }
                });

                if(optionValue){
                    if(optionValue.minCheck){
                        if(optionValue.minType == "ePayco"){
                            if(optionValue.minVal){
                                let minVal = 1;
                                let campo = configCampos.find(val => val.nombreParametro == optionValue.minVal);
                                if(campo){
                                    minVal = facturasOriginal[key][campo.tipoCampo];
                                    min.push(minVal);
                                }
                                
                            }
                        }else{
                            if(optionValue.minVal){
                                min.push(optionValue.minVal);
                            }else{
                                min.push(1);
                            }
                        }
                    }else{
                        min.push(1);
                    }

                    if(optionValue.maxCheck){
                        if(optionValue.maxType == "ePayco"){
                            if(optionValue.maxVal){
                                let maxVal = 8000000;
                                let campo = configCampos.find(val => val.nombreParametro == optionValue.maxVal);
                                if(campo){
                                    maxVal = facturasOriginal[key][campo.tipoCampo];
                                    max.push(maxVal);
                                }
                            }
                        }else{
                            if(optionValue.maxVal){
                                max.push(optionValue.maxVal);
                            }else{
                                max.push(80000000);
                            }
                        }
                    }else{
                        max.push(80000000);
                    }

                }else{
                    let valorMaximo = valores[0];
                    let valorMinimo = valores[0];
    
                    for (let i = 1; i < valores.length; i++) {
                        if (valores[i]) {
                            if (valorMaximo < valores[i]) {
                                valorMaximo = valores[i];
    
                            }
    
                            if (valorMinimo > valores[i]) {
                                valorMinimo = valores[i];
    
                            }
                        }
                    }
                    if (aux > 1) {
    
                        switch (modificarValor.opcion) {
                            case '<':
                                max[key]=parseInt(valorMaximo);
                                min[key]=1;
                                break;
                            case '>':
                                max[key]=80000000;
                                min[key]=parseInt(valorMaximo);
                                break;
                            default: return '';
                        }
                    }
                    else {
                        switch (modificarValor.opcion) {
                            case '<':
                                max[key]=valorMaximo;
                                min[key]=1;
                                break;
                            case '>':
                                max[key]=80000000;
                                min[key]=valorMaximo;
                                break;
                            default:
                                return '';
                        }
                    }
                }
            })
        }
        this.setState({
            minimos:min,
            maximos:max
        })
    }

    setInvalido(key, esInvalido) {
        let invalidos = [...this.state.invalidos];
        invalidos[key] = esInvalido;
        this.setState({ invalidos });
    }

    validarValoresPagar(valor, key) {
        // console.log(valor,key)
        let facturas = [...this.state.facturas]
        let modificarValor = this.state.opcionesRecaudo.modificarValorPagar
        let configCampos = JSON.parse(sessionStorage.getItem("configCampos"));
        let facturasOriginal = [...this.state.facturasOriginal];
        let optionValue = null;
        if(!!modificarValor.value){
            optionValue = modificarValor.value;
        }
        let keyTotal = -1;
        let keySegundoValor = -1;
        let keyTercerValor = -1;
        let aux = 0;
        facturas[0].map((fac, i) => {
            if (fac.entidad === "total") {
                keyTotal = i;
                aux++;
            }
            if (fac.entidad === "segundoTotal") {
                keySegundoValor = i;
                aux++;
            }
            if (fac.entidad === "tercerTotal") {
                keyTercerValor = i;
                aux++;
            }

            return '';
        });

        const marcarInvalido = (msg) => {
            this.setInvalido(key, true);
            this.showAlert('info', false, msg);
        };
        const marcarValido = () => {
            this.setInvalido(key, false);
            this.closedAlert();
        };

        // console.log(valor)
        // console.log(aux)
        // console.log(parseInt(valor) >= (parseInt(facturas[key][keyTotal].valor2)))

        if (parseInt(valor) <= 0) {
            this.showAlert('info', false, 'El valor debe ser mayor que cero (0)')
        }
        if (modificarValor.activo) {
            if (aux > 1) {
                // console.log(parseInt(facturas[key][keyTotal].valor2))
                switch (modificarValor.opcion) {
                    case '<':
                        if(optionValue){
                            if(optionValue.maxType == "ePayco"){
                                let maxVal = 8000000;
                                let campo = configCampos.find(val => val.nombreParametro == optionValue.maxVal);
                                if(campo){
                                    maxVal = facturasOriginal[key][campo.tipoCampo];
                                }
                                if(parseInt(valor) > maxVal || parseInt(valor) <= 0){
                                    marcarInvalido(`Solo estan permitidos valores inferiores al valor máximo ($${maxVal})`);
                                }else{
                                    marcarValido();
                                }
                            }else{
                                if(parseInt(valor) > optionValue.maxVal || parseInt(valor) <= 0){
                                    marcarInvalido(`Solo estan permitidos valores inferiores al valor máximo ($${optionValue.maxVal})`);
                                }else{
                                    marcarValido();
                                }
                            }
                        }else{
                            if (
                                parseInt(valor) > (parseInt(facturas[key][keyTotal].valor2)
                                )
                                || parseInt(valor) <= 0) {
                                marcarInvalido('Solo estan permitidos valores inferiores al valor inicial');
                            } else {
                                marcarValido();
                            }
                        }
                        break;
                    case '>':
                        // console.log(facturas[key])
                        // console.log(valor)
                        // console.log(key)
                        if(optionValue){
                            if(optionValue.minType == "ePayco"){
                                let minVal = 1;
                                let campo = configCampos.find(val => val.nombreParametro == optionValue.minVal);
                                if(campo){
                                    minVal = facturasOriginal[key][campo.tipoCampo];
                                }
                                if(parseInt(valor) < minVal || parseInt(valor) <= 0){
                                    marcarInvalido(`Solo estan permitidos valores superiores al valor mínimo ($${minVal})`);
                                }else{
                                    marcarValido();
                                }
                            }else{
                                if(parseInt(valor) < optionValue.minVal || parseInt(valor) <= 0){
                                    marcarInvalido(`Solo estan permitidos valores superiores al valor mínimo ($${optionValue.minVal})`);
                                }else{
                                    marcarValido();
                                }
                            }
                        }else{
                            if ((parseInt(valor) < parseInt(facturas[key][keyTotal].valor2) ||
                                (parseInt(valor) > (keyTercerValor !== -1
                                    ? parseInt(facturas[key][keyTercerValor].valor2)
                                    : (keySegundoValor !== -1
                                            ? parseInt(facturas[key][keySegundoValor].valor2)
                                            : parseInt(facturas[key][keyTotal].valor2)
                                    ))))
                                || parseInt(valor) <= 0) {
                                marcarInvalido('Solo estan permitidos valores superiores al valor inicial');
                            } else {
                                marcarValido();
                            }
                        }
                        break;
                    case '<>':
                        if(optionValue){
                            let minVal = optionValue.minVal ? optionValue.minVal : 1 ;
                            let maxVal = optionValue.maxVal ? optionValue.maxVal : 8000000 ;
                            if(optionValue.minType == "ePayco"){
                                let campo = configCampos.find(val => val.nombreParametro == optionValue.minVal);
                                if(campo){
                                    minVal = facturasOriginal[key][campo.tipoCampo];
                                }
                            }

                            if(optionValue.maxType == "ePayco"){
                                let campo = configCampos.find(val => val.nombreParametro == optionValue.maxVal);
                                if(campo){
                                    maxVal = facturasOriginal[key][campo.tipoCampo];
                                }
                            }
                            
                            if(parseInt(valor) < minVal || parseInt(valor) > maxVal){
                                marcarInvalido(`Solo estan permitidos valores entre el valor mínimo ($${minVal}) y máximo ($${maxVal})`);
                            }else{
                                marcarValido();
                            }
                        }
                        break;
                    default:
                        marcarValido();

                }
            } else {
                switch (modificarValor.opcion) {
                    case '<':

                        if(optionValue){
                            if(optionValue.maxType == "ePayco"){
                                let maxVal = 8000000;
                                let campo = configCampos.find(val => val.nombreParametro == optionValue.maxVal);
                                if(campo){
                                    maxVal = facturasOriginal[key][campo.tipoCampo];
                                }
                                if(parseInt(valor) > maxVal || parseInt(valor) <= 0){
                                    marcarInvalido(`Solo estan permitidos valores inferiores al valor máximo ($${maxVal})`);
                                }else{
                                    marcarValido();
                                }
                            }else{
                                if(parseInt(valor) > optionValue.maxVal || parseInt(valor) <= 0){
                                    marcarInvalido(`Solo estan permitidos valores inferiores al valor máximo ($${optionValue.maxVal})`);
                                }else{
                                    marcarValido();
                                }
                            }
                        }else{
                            if (
                                parseInt(valor) > (keyTercerValor !== -1
                                ? parseInt(facturas[key][keyTercerValor].valor2)
                                : (keySegundoValor !== -1
                                        ? parseInt(facturas[key][keySegundoValor].valor2)
                                        : parseInt(facturas[key][keyTotal].valor2)
                                ))
                                || parseInt(valor) <= 0) {
                                marcarInvalido('Solo estan permitidos valores inferiores al valor inicial');
                            } else {
                                marcarValido();
                            }
                        }
                        break;
                    case '>':
                        // console.log(facturas[key])
                        // console.log(valor)
                        // console.log(key)
                        if(optionValue){
                            if(optionValue.minType == "ePayco"){
                                let minVal = 1;
                                let campo = configCampos.find(val => val.nombreParametro == optionValue.minVal);
                                if(campo){
                                    minVal = facturasOriginal[key][campo.tipoCampo];
                                }
                                if(parseInt(valor) < minVal || parseInt(valor) <= 0){
                                    marcarInvalido(`Solo estan permitidos valores superiores al valor mínimo ($${minVal})`);
                                }else{
                                    marcarValido();
                                }
                            }else{
                                if(parseInt(valor) < optionValue.minVal || parseInt(valor) <= 0){
                                    marcarInvalido(`Solo estan permitidos valores superiores al valor mínimo ($${optionValue.minVal})`);
                                }else{
                                    marcarValido();
                                }
                            }
                        }else{
                            if (parseInt(valor) < (keyTercerValor !== -1
                                ? parseInt(facturas[key][keyTercerValor].valor2)
                                : (keySegundoValor !== -1
                                        ? parseInt(facturas[key][keySegundoValor].valor2)
                                        : parseInt(facturas[key][keyTotal].valor2)
                                ))
                                || parseInt(valor) <= 0) {
                                marcarInvalido('Solo estan permitidos valores superiores al valor inicial');
                            } else {
                                marcarValido();
                            }
                        }
                        break;
                    case '<>':
                        if(optionValue){
                            let minVal = optionValue.minVal ? optionValue.minVal : 1 ;
                            let maxVal = optionValue.maxVal ? optionValue.maxVal : 8000000 ;
                            if(optionValue.minType == "ePayco"){
                                let campo = configCampos.find(val => val.nombreParametro == minVal);
                                if(campo){
                                    minVal = facturasOriginal[key][campo.tipoCampo];
                                }
                            }

                            if(optionValue.maxType == "ePayco"){
                                let campo = configCampos.find(val => val.nombreParametro == maxVal);
                                if(campo){
                                    maxVal = facturasOriginal[key][campo.tipoCampo];
                                }
                            }
                            if(parseInt(valor) < minVal || parseInt(valor) > maxVal){
                                marcarInvalido(`Solo estan permitidos valores entre el valor mínimo ($${minVal}) y máximo ($${maxVal})`);
                            }else{
                                marcarValido();
                            }
                        }
                        break;
                    default:
                        marcarValido();
                }
            }
        }

    }

    salirCambiarPantalla() {
        this.setState({
            cambiarPantalla: false
        })
    }

    pagarFacturas() {
        let facturaPagar = [];
        this.state.checks.map((it, key) => {
            if (it && key<this.state.facturas.length) {
                facturaPagar.push(key);
            }
        })
        let facturas = [...this.state.facturas]
        let configCampos = JSON.parse(sessionStorage.getItem("configCampos"));
        let facturasOriginal = [...this.state.facturasOriginal];
        let modificarValor = this.state.opcionesRecaudo.modificarValorPagar
        let optionValue = null;
        if(!!modificarValor.value){
            optionValue = modificarValor.value;
        }
        // console.log("Check:::", facturaPagar)
        // console.log("Check:::", facturas)
        let error = false;
        if (this.state.checksOtroValor && this.state.checksOtroValor.length >= facturaPagar.length) {
            facturaPagar.forEach((fact,k)=>{
                // console.log("Factura pagar::",fact)
                if (this.state.valuesOtroValor[fact] <= 0) this.showAlert('info', false, 'El valor debe ser mayor que cero (0)')
                else {
                    let keyTotal = -1;
                    let keySegundoValor = -1;
                    let keyTercerValor = -1;
                    let aux = 0;
                    let key = fact;
                    let valor = this.state.valuesOtroValor[fact];
                    facturas[fact].map((fac, i) => {
                        if (fac.entidad === "total") {
                            keyTotal = i;
                            aux++;
                        }
                        if (fac.entidad === "segundoTotal") {
                            keySegundoValor = i;
                            aux++;
                        }
                        if (fac.entidad === "tercerTotal") {
                            keyTercerValor = i;
                            aux++;
                        }
                        return '';
                    });
                    // console.log(modificarValor.opcion)
                    if (modificarValor.activo && !error) {
                        if (aux > 1) {
                            let valores = [];
                            let valoresMoneda = [];
                            facturas[key].filter((infoFac) => {
                                if (infoFac.entidad === "total" || infoFac.entidad === "segundoTotal" || infoFac.entidad === "tercerTotal") {
                                    valores.push(infoFac.valor2);
                                    valoresMoneda.push(infoFac.valor);
                                }
                            });


                            let valorMaximo = valores[0];
                            let valorMaximoMoneda = valoresMoneda[0];
                            let valorMinimo = valores[0];

                            for (let i = 1; i < valores.length; i++) {
                                if (valores[i]) {
                                    if (valorMaximo < valores[i]) {
                                        valorMaximo = valores[i];
                                        valorMaximoMoneda = valoresMoneda[i];
                                    }

                                    if (valorMinimo > valores[i]) {
                                        valorMinimo = valores[i];

                                    }
                                }
                            }
                            if (this.state.opcionesRecaudo.modificarValorPagar.opcion === "<" && valor > valorMaximo) {
                                this.showAlert('info', false, `Supera el valor máximo (${valorMaximoMoneda}) permitido a pagar de la factura ${fact + 1}`)
                                error = true;
                            } else if (this.state.opcionesRecaudo.modificarValorPagar.opcion === ">" && valor < valorMaximo) {
                                this.showAlert('info', false, `No supera el valor mínimo (${valorMaximoMoneda}) permitido a pagar de la factura ${fact + 1}`
                                );
                                error = true;
                            } else {
                                this.closedAlert()
                            }
                        } else {
                            switch (modificarValor.opcion) {
                                case '<':
                                    if(optionValue){
                                        if(optionValue.maxType == "ePayco"){
                                            let maxVal = 8000000;
                                            let campo = configCampos.find(val => val.nombreParametro == optionValue.maxVal);
                                            if(campo){
                                                maxVal = facturasOriginal[0][campo.tipoCampo];
                                            }
                                            if(parseInt(valor) > maxVal || parseInt(valor) <= 0){
                                                error = true;
                                                this.showAlert('info', false, `Solo estan permitidos valores inferiores al valor máximo ($${maxVal})`)
                                            }else{
                                                this.closedAlert();
                                            }
                                        }else{
                                            if(parseInt(valor) > optionValue.maxVal || parseInt(valor) <= 0){
                                                error = true;
                                                this.showAlert('info', false, `Solo estan permitidos valores inferiores al valor máximo ($${optionValue.maxVal})`)
                                            }else{
                                                this.closedAlert();
                                                this.props.history.push({
													pathname: ruta.factura,
													isSuscrito:
														this.props.location
															.isSuscrito ||
														false,
												});
                                                
                                            }
                                        }
                                    }else{
                                        if (
                                            parseInt(valor) > (keyTercerValor !== -1
                                            ? parseInt(facturas[key][keyTercerValor].valor2)
                                            : (keySegundoValor !== -1
                                                    ? parseInt(facturas[key][keySegundoValor].valor2)
                                                    : parseInt(facturas[key][keyTotal].valor2)
                                            ))
                                            || parseInt(valor) <= 0) {
                                                error = true;
                                                this.showAlert('info', false, 'Solo estan permitidos valores inferiores al valor inicial')
                                        } else {
                                            this.closedAlert()
                                            this.props.history.push({
												pathname: ruta.factura,
												isSuscrito:
													this.props.location
														.isSuscrito || false,
											});
                                        }
                                    }
                                    break;
                                case '>':
                                    // console.log(facturas[key])
                                    // console.log(valor)
                                    // console.log(key)
                                    if(optionValue){
                                        if(optionValue.minType == "ePayco"){
                                            let minVal = 1;
                                            let campo = configCampos.find(val => val.nombreParametro == optionValue.minVal);
                                            if(campo){
                                                minVal = facturasOriginal[0][campo.tipoCampo];
                                            }
                                            if(parseInt(valor) < minVal || parseInt(valor) <= 0){
                                                error = true;
                                                this.showAlert('info', false, `Solo estan permitidos valores superiores al valor mínimo ($${minVal})`)
                                            }else{
                                                this.closedAlert();
                                            }
                                        }else{
                                            if(parseInt(valor) < optionValue.minVal || parseInt(valor) <= 0){
                                                error = true;
                                                this.showAlert('info', false, `Solo estan permitidos valores superiores al valor mínimo ($${optionValue.minVal})`)
                                            }else{
                                                this.closedAlert();
                                                this.props.history.push({
													pathname: ruta.factura,
													isSuscrito:
														this.props.location
															.isSuscrito ||
														false,
												});
                                            }
                                        }
                                    }else{
                                        if (parseInt(valor) < (keyTercerValor !== -1
                                            ? parseInt(facturas[key][keyTercerValor].valor2)
                                            : (keySegundoValor !== -1
                                                    ? parseInt(facturas[key][keySegundoValor].valor2)
                                                    : parseInt(facturas[key][keyTotal].valor2)
                                            ))
                                            || parseInt(valor) <= 0) {
                                            error = true;
                                            this.showAlert('info', false, 'Solo estan permitidos valores superiores al valor inicial')
                                        } else {
                                            this.closedAlert()
                                            this.props.history.push({
												pathname: ruta.factura,
												isSuscrito:
													this.props.location
														.isSuscrito || false,
											});
                                        }
                                    }
                                    break;
                                case '<>':
                                    if(optionValue){
                                        let minVal = optionValue.minVal ? optionValue.minVal : 1 ;
                                        let maxVal = optionValue.maxVal ? optionValue.maxVal : 8000000 ;

                                        if(optionValue.minType == "ePayco"){
                                            let campo = configCampos.find(val => val.nombreParametro == minVal);
                                            if(campo){
                                                minVal = facturasOriginal[0][campo.tipoCampo];
                                            }
                                        }
            
                                        if(optionValue.maxType == "ePayco"){
                                            let campo = configCampos.find(val => val.nombreParametro == maxVal);
                                            if(campo){
                                                maxVal = facturasOriginal[0][campo.tipoCampo];
                                            }
                                        }
                                        console.log("valores",valor,minVal,maxVal);
                                        if(parseInt(valor) < minVal || parseInt(valor) > maxVal){
                                            error = true;
                                            this.showAlert('info', false, `Solo estan permitidos valores entre el valor mínimo ($${minVal}) y máximo ($${maxVal})`)
                                        }else{
                                            this.closedAlert();
                                            this.props.history.push({
												pathname: ruta.factura,
												isSuscrito:
													this.props.location
														.isSuscrito || false,
											});
                                        }
                                    }
                                    break;
                            }
                        }
                    }
                }
            })
        }

        if(!error){
            sessionStorage.setItem("check", JSON.stringify((this.state.checks)));
            sessionStorage.setItem("checksOtroValor", JSON.stringify((this.state.checksOtroValor)));
            sessionStorage.setItem("checksValor1", JSON.stringify((this.state.checksValor1)));
            sessionStorage.setItem("checksValor2", JSON.stringify((this.state.checksValor2)));
            sessionStorage.setItem("checksValor3", JSON.stringify((this.state.checksValor3)));
            sessionStorage.setItem("valuesOtroValor", JSON.stringify((this.state.valuesOtroValor)));
            sessionStorage.setItem("facturaPagar", JSON.stringify(facturaPagar));
            this.props.history.push({pathname: ruta.factura, isSuscrito: this.props.location.isSuscrito || false });
        }

    }

    showAlert(type = 'info', isDelay = false, message = ''){
        this.setState({
            showMessage: {
                open: true,
                type: type,
                isDelay: isDelay,
                message : message
            }
        }, () =>{
            if(isDelay){
                setTimeout(function(){
                    this.setState({
                        showMessage:{
                            open: false,
                            type: 'info',
                            isDelay: false,
                            message : ''
                        },
                    })
                }, 5000);
            }
        })
    }

    closedAlert(){
        this.setState({
            showMessage:{
                open: false,
                type: 'info',
                isDelay: false,
                message : ''
            },
        })
    }

    componentDidMount() {
        // his.request();
        this.verData();
        if(sessionStorage.getItem('opcionesRecaudo')){
            let opcionRecaudo = sessionStorage.getItem('opcionesRecaudo')
            this.setState({
                opcionesRecaudo : JSON.parse(opcionRecaudo),
            })
        }
    }

    verData(){
        const getTipoMoneda = (moneda) => {
            let tipoMoneda = moneda;
            if(tipoMoneda){
                tipoMoneda = tipoMoneda ? tipoMoneda.value : 'COP'
            }else{
                tipoMoneda = 'COP'
            }
            return tipoMoneda ? tipoMoneda : 'COP';
        }
        let facturas = JSON.parse(sessionStorage.getItem("facturas"));
        let configCampos = JSON.parse(sessionStorage.getItem("configCampos"));
        let total = sessionStorage.getItem("total");
        // let paginacion = JSON.parse(sessionStorage.getItem("paginacion"));
        const opcionesRecaudo = sessionStorage.getItem("opcionesRecaudo");
        const moneda = getTipoMoneda(JSON.parse(opcionesRecaudo).moneda)
        let check=[];
        let checksOtroValor=[];
        let checksValor1=[];
        let checksValor2=[];
        let checksValor3=[];
        let valuesOtroValor=[];
        let session=false;
        if(sessionStorage.getItem("check")){
            check=JSON.parse(sessionStorage.getItem("check"));
            checksOtroValor =JSON.parse(sessionStorage.getItem("checksOtroValor"));
            checksValor1=JSON.parse(sessionStorage.getItem("checksValor1"));
            checksValor2=JSON.parse(sessionStorage.getItem("checksValor2"));
            checksValor3=JSON.parse(sessionStorage.getItem("checksValor3"));
            valuesOtroValor=JSON.parse(sessionStorage.getItem("valuesOtroValor"));
            check.forEach((c)=>{
                if(c)session=true;
            })
        }


        let tituloFactura="";


        if (facturas && facturas.length > 0) {
            let newFacturas = [];
            facturas.map((fac,fa) => {
                if(!session){
                    check.push(false);
                    checksOtroValor.push(false);
                    checksValor1.push(false);
                    checksValor2.push(false);
                    checksValor3.push(false);
                    valuesOtroValor.push(0);
                }
                let config=[];
                configCampos.map((conf) => {
                    let data = {};
                    let numeroFactura=false;
                    Object.keys(fac).filter((k) => {
                            if (k === conf.tipoCampo && (conf.tipoCampo === "facturaId" || conf.tipoCampo === "total"  || conf.tipoCampo === "segundoTotal" || conf.tipoCampo === "tercerTotal") && conf.visible) {
                                data["titulo"] = conf.nombreCampo;
                                data['entidad'] = conf.tipoCampo
                                if (conf.tipoCampo==="total" || conf.tipoCampo==="segundoTotal" || conf.tipoCampo==="tercerTotal") {
                                    data["valor"] = `$${parseFloat(fac[k]).toLocaleString('en-US', {minimumFractionDigits: 0})} ${moneda}`;
                                    data["valor2"] = parseFloat(fac[k]);
                                    data['entidad'] = conf.tipoCampo
                                    if(conf.tipoCampo === "total"){
                                        data["opcion"] =1;
                                        tituloFactura = conf.nombreCampo;
                                        numeroFactura=true;
                                    }
                                } else {
                                    if(conf.tipoCampo === "facturaId"){
                                        numeroFactura=true;
                                    }
                                    data["valor"] = fac[k];
                                }

                            }
                            return '';
                    });
                    if(numeroFactura){
                        config.unshift(data);
                    }else{
                        config.push(data);
                    }
                });
                newFacturas.push(config)

            });
            // total=`${total} ${moneda}`;
            let filtered = [];
            newFacturas.filter((fac) => {
                let data = fac.filter((camp) => {
                    return Object.keys(camp).length > 0;
                });
                filtered.push(data);
                return ''
            });

            sessionStorage.setItem("check",JSON.stringify((check)));
            sessionStorage.setItem("checksOtroValor",JSON.stringify((checksOtroValor)));
            sessionStorage.setItem("checksValor1",JSON.stringify((checksValor1)));
            sessionStorage.setItem("checksValor2",JSON.stringify((checksValor2)));
            sessionStorage.setItem("checksValor3",JSON.stringify((checksValor3)));
            sessionStorage.setItem("valuesOtroValor",JSON.stringify((valuesOtroValor)));



            let allCheck=true;
            check.forEach((c)=>{
                if(!c)allCheck=false
            })
            this.setState({
                allCheck:allCheck,
                facturas: filtered,
                facturasOriginal:facturas,
                configCampos,
                total,
                checks:check,
                checksOtroValor:checksOtroValor,
                checksValor1:checksValor1,
                checksValor2:checksValor2,
                checksValor3:checksValor3,
                valuesOtroValor:valuesOtroValor,
                // paginacion,
                // hasMoreItems:paginacion.to<paginacion.total,
                moneda,
                tituloFactura,
                procesando:false
            },()=>{
                this.minMax();
                this.valorTotal();
                }
            );
        } else {
            // alert("No existen facturas");
            this.props.openModal("No se encontraron facturas.", "danger")
            this.props.history.push(ruta.home);
        }
    }
    FormatoCampo(Value, Moneda, tipo_campo_2){
        let valor = "";
        switch (tipo_campo_2) {
            case 'moneda':
                valor = `$ ${parseFloat(Value).toLocaleString("en-US", {
                    minimumFractionDigits: 0
                })} ${Moneda}`;
                break;
            case 'numerico':
                valor = parseFloat(Value).toLocaleString("en-US", {
                    minimumFractionDigits: 0
                });
                break;
            case 'porcentaje':
                valor = `${parseFloat(Value).toLocaleString("en-US", {
                    minimumFractionDigits: 0
                })} %`;
                break;
            default:
                valor = Value
                break;
        }
        return valor;
    }
    getTipoMoneda(){
        let tipoMoneda = sessionStorage.getItem('configuracion');
        if(tipoMoneda){
            tipoMoneda = JSON.parse(tipoMoneda)
            tipoMoneda = tipoMoneda.busqueda.find( el => el.campoDb.toLowerCase() == 'total')
            tipoMoneda = tipoMoneda ? tipoMoneda.moneda : 'COP'
        }else{
            tipoMoneda = 'COP'
        }
        return tipoMoneda ? tipoMoneda : 'COP';
    }
    showModal(key = null){
        let facturas = JSON.parse(sessionStorage.getItem('facturas'))
        let factura = key != null ? facturas[key] : null
        let campos = [...this.state.configCampos]
        let data = []
        const Moneda = this.getTipoMoneda();
        if(factura){
            Object.entries(factura).forEach(([i, value]) => {
                if(value != null){
                    let config = campos.filter(f => f.tipoCampo === i)[0]
                    if(config && config.visible){
                        if(config.campoDb == "extras"){
                            data.push({'llave': config.nombreCampo, 'valor': this.FormatoCampo(value, Moneda, config.tipo_campo_2), 'entidad': config.tipoCampo})
                        }else{
                            data.push({'llave': config.nombreCampo, 'valor': value, 'entidad': config.tipoCampo})
                        }
                    }
                }
            });
        }
        this.setState({
            showModal:{
                activo: !this.state.showModal.activo,
                data: data
            }
        })
    }

    loadFunc(page){
        // console.log("holaa",page);
        // this.buscarFactura();
    }

    onChangeCheck(key, all = false) {
        // console.log("onchange",key, all)
        let checks = [...this.state.checks];
        let checksOtroValor = [...this.state.checksOtroValor];
        let checksValor1 = [...this.state.checksValor1];
        let checksValor2 = [...this.state.checksValor2];
        let checksValor3 = [...this.state.checksValor3];

        let allCheckState = this.state.allCheck;
        let totalPagar = this.state.totalPagar;
        let configCampos = JSON.parse(sessionStorage.getItem("configCampos"));
        if (all) {

            // console.log(checks);
            let allCheck = checks.map((al, k) => {
                let aux=0;
                if (allCheckState) {
                    all = false;
                    checksOtroValor[k] = false;
                    checksValor1[k] = false;
                    checksValor2[k] = false;
                    checksValor3[k] = false;
                    totalPagar = 0;
                    return false
                } else {
                    all = true;
                    if (!checksOtroValor[k] && !checksValor1[k] && !checksValor2[k] && !checksValor3[k]) {
                        // console.log("aqui",!checksValor1[k]&&!checksValor2[k]&&!checksValor3[k])
                        while((!checksValor1[k]&&!checksValor2[k]&&!checksValor3[k]) || aux===3){
                            aux++;
                            configCampos.map((cc) => {
                                if (cc.tipoCampo === "total" && cc.visible && aux===1) {
                                    checksValor1[k] = true;
                                } else if (cc.tipoCampo === "segundoTotal" && cc.visible && !checksValor1[k] && aux===2) {
                                    checksValor2[k] = true;
                                } else if (cc.tipoCampo === "tercerTotal" && cc.visible && !checksValor1[k] && !checksValor2[k] && aux===3) {
                                    checksValor3[k] = true;
                                }
                            })
                        }
                    }

                    return true;
                }
            });

            checks = allCheck;
        }
        else {
            checks[key] = !checks[key];
            if (checks[key]) {
                let aux =0;
                while((!checksValor1[key]&&!checksValor2[key]&&!checksValor3[key]) || aux ===3){
                    aux++;
                    configCampos.map((cc) => {
                        if (cc.tipoCampo === "total" && cc.visible && aux ===1) {
                            checksValor1[key] = true;
                        } else if (cc.tipoCampo === "segundoTotal" && cc.visible && !checksValor1[key] && aux ===2) {
                            checksValor2[key] = true;
                        } else if (cc.tipoCampo === "tercerTotal" && cc.visible && !checksValor1[key] && !checksValor2[key] && aux ===3) {
                            checksValor3[key] = true;
                        }
                    })
                }

            } else {
                checksOtroValor[key] = false;
                checksValor1[key] = false;
                checksValor2[key] = false;
                checksValor3[key] = false;
            }

            if (checks[key] === false) all = false;
            let aux = false;
            checks.map((it, i) => {
                if (it === false) {
                    all = false;
                    aux = true;
                } else if (i === checks.length - 1 && it && !aux) {
                    all = true;
                }
                return '';
            })
        }


        let tieneAgrupacion = this.state.opcionesRecaudo && this.state.opcionesRecaudo !== "" && this.state.opcionesRecaudo.agruparFacturas.activo;
        if (!tieneAgrupacion) {
            checks.map((ch, i) => {
                checks[i] = false;
                return '';
            });
        }
        this.setState({
            checks,
            allCheck: all,
            totalPagar,
            checksOtroValor,
            checksValor1,
            checksValor2,
            checksValor3,
        }, () => this.valorTotal())
    }

    pagar(key) {
        let opcionesRecaudo = this.state.opcionesRecadudo || JSON.parse(sessionStorage.getItem('opcionesRecaudo'))
        sessionStorage.setItem("facturaPagar", key);
        sessionStorage.setItem("check", JSON.stringify((this.state.checks)));
        sessionStorage.setItem("checksOtroValor", JSON.stringify((this.state.checksOtroValor)));
        sessionStorage.setItem("checksValor1", JSON.stringify((this.state.checksValor1)));
        sessionStorage.setItem("checksValor2", JSON.stringify((this.state.checksValor2)));
        sessionStorage.setItem("checksValor3", JSON.stringify((this.state.checksValor3)));
        sessionStorage.setItem("valuesOtroValor", JSON.stringify((this.state.valuesOtroValor)));
        let configCampos = JSON.parse(sessionStorage.getItem("configCampos"));
        let facturasOriginal = [...this.state.facturasOriginal];
        let activo = true

        if (opcionesRecaudo != "" && opcionesRecaudo && opcionesRecaudo.multiplesValoresPago.activo) {
            activo = false
            this.state.checks.map((item) => {
                if (item) {
                    activo = true
                }
            })

            if (!activo) {
                this.state.checksValor1.map((item) => {
                    if (item) {
                        activo = true
                    }
                })
            }

            if (!activo) {
                this.state.checksValor2.map((item) => {
                    if (item) {
                        activo = true
                    }
                })
            }

            if (!activo) {
                this.state.checksValor3.map((item) => {
                    if (item) {
                        activo = true
                    }
                })
            }

            let stop = false;
            this.state.checksOtroValor.map((item, k) => {
                if (item) {
                    // console.log(this.state.valuesOtroValor)
                    if (this.state.valuesOtroValor[k] <= 0 && key === k) {
                        this.showAlert('info', false, 'El valor debe ser mayor que cero (0)')
                        stop = true;
                    } else {
                        activo = true
                    }
                }
            })
            if (stop) return;

            if (!activo) {
                toast.warning('Debe seleccionar por lo menos un valor para realizar el pago')
            }
        }
        if(this.state.checksOtroValor[key]){
            if (activo) {
                let modificarValor = this.state.opcionesRecaudo.modificarValorPagar
                let optionValue = null;
                if(!!modificarValor.value){
                    optionValue = modificarValor.value;
                }
                if (modificarValor && modificarValor.activo) {
                    let facturas = [...this.state.facturas]
                    let keyTotal = -1;
                    let keySegundoValor = -1;
                    let keyTercerValor = -1;
                    let aux = 0;

                    let valor = this.state.valuesOtroValor[key];
                    facturas[0].map((fac, i) => {
                        if (fac.entidad === "total") {
                            keyTotal = i;
                            aux++;
                        }
                        if (fac.entidad === "segundoTotal") {
                            keySegundoValor = i;
                            aux++;
                        }
                        if (fac.entidad === "tercerTotal") {
                            keyTercerValor = i;
                            aux++;
                        }
                    });
                    if (aux > 1) {
                        if(optionValue){
                            switch (modificarValor.opcion) {
                                case '<':
                                    if(optionValue.maxType == "ePayco"){
                                        let maxVal = 8000000;
                                        let campo = configCampos.find(val => val.nombreParametro == optionValue.maxVal);
                                        if(campo){
                                            maxVal = facturasOriginal[key][campo.tipoCampo];
                                        }
                                        if(parseInt(valor) > maxVal || parseInt(valor) <= 0){
                                            this.showAlert('info', false, `Solo estan permitidos valores inferiores al valor máximo ($${maxVal})`)
                                        }else{
                                            this.closedAlert();
                                            this.props.history.push({
												pathname: ruta.factura,
												isSuscrito:
													this.props.location
														.isSuscrito || false,
											});
                                        }
                                    }else{
                                        if(parseInt(valor) > optionValue.maxVal || parseInt(valor) <= 0){
                                            this.showAlert('info', false, `Solo estan permitidos valores inferiores al valor máximo ($${optionValue.maxVal})`)
                                        }else{
                                            this.closedAlert();
                                            this.props.history.push({
												pathname: ruta.factura,
												isSuscrito:
													this.props.location
														.isSuscrito || false,
											});
                                        }
                                    }
                                    break;
                                case '>':
                                    if(optionValue.minType == "ePayco"){
                                        let minVal = 1;
                                        let campo = configCampos.find(val => val.nombreParametro == optionValue.minVal);
                                        if(campo){
                                            minVal = facturasOriginal[key][campo.tipoCampo];
                                        }
                                        if(parseInt(valor) < minVal || parseInt(valor) <= 0){
                                            this.showAlert('info', false, `Solo estan permitidos valores superiores al valor mínimo ($${minVal})`)
                                        }else{
                                            this.closedAlert();
                                            this.props.history.push({
                                                pathname: ruta.factura,
                                                isSuscrito: this.props.location.isSuscrito || false,
                                            });
                                        }
                                    }else{
                                        if(parseInt(valor) < optionValue.minVal || parseInt(valor) <= 0){
                                            this.showAlert('info', false, `Solo estan permitidos valores superiores al valor mínimo ($${optionValue.minVal})`)
                                        }else{
                                            this.closedAlert();
                                            this.props.history.push({
												pathname: ruta.factura,
												isSuscrito:
													this.props.location
														.isSuscrito || false,
											});
                                        }
                                    }
                                    break;
                                case '<>':
                                    let minVal = optionValue.minVal ? optionValue.minVal : 1 ;
                                    let maxVal = optionValue.maxVal ? optionValue.maxVal : 8000000 ;

                                    if(optionValue.minType == "ePayco"){
                                        let campo = configCampos.find(val => val.nombreParametro == minVal);
                                        if(campo){
                                            minVal = facturasOriginal[key][campo.tipoCampo];
                                        }
                                    }
        
                                    if(optionValue.maxType == "ePayco"){
                                        let campo = configCampos.find(val => val.nombreParametro == maxVal);
                                        if(campo){
                                            maxVal = facturasOriginal[key][campo.tipoCampo];
                                        }
                                    }
                                    if(parseInt(valor) < minVal || parseInt(valor) > maxVal){
                                        this.showAlert('info', false, `Solo estan permitidos valores entre el valor mínimo ($${minVal}) y máximo ($${maxVal})`)
                                    }else{
                                        this.closedAlert();
                                        this.props.history.push({
											pathname: ruta.factura,
											isSuscrito:
												this.props.location
													.isSuscrito || false,
										});
                                    }
                                    break;
                                default:
                                    this.props.history.push({
										pathname: ruta.factura,
										isSuscrito:
											this.props.location.isSuscrito ||
											false,
									});
                                    this.closedAlert()
                            }
                        }else{
                            let valores = [];
                            let valoresMoneda = [];
                            facturas[key].filter((infoFac) => {
                                if (infoFac.entidad === "total" || infoFac.entidad === "segundoTotal" || infoFac.entidad === "tercerTotal") {
                                    valores.push(infoFac.valor2);
                                    valoresMoneda.push(infoFac.valor);
                                }
                            });
    
    
                            let valorMaximo = valores[0];
                            let valorMaximoMoneda = valoresMoneda[0];
                            let valorMinimo = valores[0];
                            for (let i = 1; i < valores.length; i++) {
                                if (valores[i]) {
                                    if (valorMaximo < valores[i]) {
                                        valorMaximo = valores[i];
                                        valorMaximoMoneda = valoresMoneda[i];
                                    }
    
                                    if (valorMinimo > valores[i]) {
                                        valorMinimo = valores[i];
                                    }
                                }
                            }
                            if (modificarValor.opcion === "<" && valor > valorMaximo) {
                                this.showAlert('info', false, `Supera el valor máximo (${valorMaximoMoneda}) permitido a pagar de la factura`)
                            } else if (modificarValor.opcion === ">" && valor < valorMaximo) {
                                this.showAlert('info', false, `Supera el valor mínimo (${valorMaximoMoneda}) permitido a pagar de la factura`)
                            } else {
                                this.closedAlert()
                                this.props.history.push({
									pathname: ruta.factura,
									isSuscrito:
										this.props.location.isSuscrito || false,
								});
                            }
                        }

                    } else {
                        switch (modificarValor.opcion) {
                            case '<':
                                if(optionValue){
                                    if(optionValue.maxType == "ePayco"){
                                        let maxVal = 8000000;
                                        let campo = configCampos.find(val => val.nombreParametro == optionValue.maxVal);
                                        if(campo){
                                            maxVal = facturasOriginal[key][campo.tipoCampo];
                                        }
                                        if(parseInt(valor) > maxVal || parseInt(valor) <= 0){
                                            this.showAlert('info', false, `Solo estan permitidos valores inferiores al valor máximo ($${maxVal})`)
                                        }else{
                                            this.closedAlert();
                                            this.props.history.push({
												pathname: ruta.factura,
												isSuscrito:
													this.props.location
														.isSuscrito || false,
											});
                                        }
                                    }else{
                                        if(parseInt(valor) > optionValue.maxVal || parseInt(valor) <= 0){
                                            this.showAlert('info', false, `Solo estan permitidos valores inferiores al valor máximo ($${optionValue.maxVal})`)
                                        }else{
                                            this.closedAlert();
                                            this.props.history.push({
												pathname: ruta.factura,
												isSuscrito:
													this.props.location
														.isSuscrito || false,
											});
                                        }
                                    }
                                }else{
                                    if (
                                        parseInt(valor) > (keyTercerValor !== -1
                                        ? parseInt(facturas[key][keyTercerValor].valor2)
                                        : (keySegundoValor !== -1
                                                ? parseInt(facturas[key][keySegundoValor].valor2)
                                                : parseInt(facturas[key][keyTotal].valor2)
                                        ))
                                        || parseInt(valor) <= 0) {
                                        this.showAlert('info', false, 'Solo estan permitidos valores inferiores al valor inicial')
                                    } else {
                                        this.closedAlert()
                                        this.props.history.push({
											pathname: ruta.factura,
											isSuscrito:
												this.props.location
													.isSuscrito || false,
										});
                                    }
                                }
                                break;
                            case '>':
                                // console.log(facturas[key])
                                // console.log(valor)
                                // console.log(key)
                                if(optionValue){
                                    if(optionValue.minType == "ePayco"){
                                        let minVal = 1;
                                        let campo = configCampos.find(val => val.nombreParametro == optionValue.minVal);
                                        if(campo){
                                            minVal = facturasOriginal[key][campo.tipoCampo];
                                        }
                                        if(parseInt(valor) < minVal || parseInt(valor) <= 0){
                                            this.showAlert('info', false, `Solo estan permitidos valores superiores al valor mínimo ($${minVal})`)
                                        }else{
                                            this.closedAlert();
                                            this.props.history.push({
												pathname: ruta.factura,
												isSuscrito:
													this.props.location
														.isSuscrito || false,
											});
                                        }
                                    }else{
                                        if(parseInt(valor) < optionValue.minVal || parseInt(valor) <= 0){
                                            this.showAlert('info', false, `Solo estan permitidos valores superiores al valor mínimo ($${optionValue.minVal})`)
                                        }else{
                                            this.closedAlert();
                                            this.props.history.push({
												pathname: ruta.factura,
												isSuscrito:
													this.props.location
														.isSuscrito || false,
											});
                                        }
                                    }
                                }else{
                                    if (parseInt(valor) < (keyTercerValor !== -1
                                        ? parseInt(facturas[key][keyTercerValor].valor2)
                                        : (keySegundoValor !== -1
                                                ? parseInt(facturas[key][keySegundoValor].valor2)
                                                : parseInt(facturas[key][keyTotal].valor2)
                                        ))
                                        || parseInt(valor) <= 0) {
                                        this.showAlert('info', false, 'Solo estan permitidos valores superiores al valor inicial')
                                    } else {
                                        this.closedAlert()
                                        this.props.history.push({
											pathname: ruta.factura,
											isSuscrito:
												this.props.location
													.isSuscrito || false,
										});
                                    }
                                }
                                break;
                            case '<>':
                                if(optionValue){
                                    let minVal = optionValue.minVal ? optionValue.minVal : 1 ;
                                    let maxVal = optionValue.maxVal ? optionValue.maxVal : 8000000 ;

                                    if(optionValue.minType == "ePayco"){
                                        let campo = configCampos.find(val => val.nombreParametro == minVal);
                                        if(campo){
                                            minVal = facturasOriginal[key][campo.tipoCampo];
                                        }
                                    }
        
                                    if(optionValue.maxType == "ePayco"){
                                        let campo = configCampos.find(val => val.nombreParametro == maxVal);
                                        if(campo){
                                            maxVal = facturasOriginal[key][campo.tipoCampo];
                                        }
                                    }
                                    if(parseInt(valor) < minVal || parseInt(valor) > maxVal){
                                        this.showAlert('info', false, `Solo estan permitidos valores entre el valor mínimo ($${minVal}) y máximo ($${maxVal})`)
                                    }else{
                                        this.closedAlert();
                                        this.props.history.push({
											pathname: ruta.factura,
											isSuscrito:
												this.props.location
													.isSuscrito || false,
										});
                                    }
                                }
                                break;
                            default:
                                this.props.history.push({
									pathname: ruta.factura,
									isSuscrito:
										this.props.location.isSuscrito || false,
								});
                                this.closedAlert()
                        }
                    }
                }
                else {
                    this.props.history.push({
						pathname: ruta.factura,
						isSuscrito: this.props.location.isSuscrito || false,
					});
                }
            }
        }
        else if(activo){
            this.props.history.push({
				pathname: ruta.factura,
				isSuscrito: this.props.location.isSuscrito || false,
			});
        }


    }

    onChangeOtroValor(valor, key) {

        let checks = [...this.state.checks];
        let checksOtroValor = [...this.state.checksOtroValor];
        let checksValor1 = [...this.state.checksValor1];
        let checksValor2 = [...this.state.checksValor2];
        let checksValor3 = [...this.state.checksValor3];
        let valuesOtroValor = [...this.state.valuesOtroValor];

        checksOtroValor[key] = true;
        checks[key] = true;
        checksValor1[key] = false;
        checksValor2[key] = false;
        checksValor3[key] = false;
        let decimal = false;
        if(this.state.opcionesRecaudo.decimal){
            decimal = this.state.opcionesRecaudo.decimal.value != "none" ? true : false
        }
        if(valor){
            valuesOtroValor[key] = decimal ? Number(valor.replace(/[^0-9.]+/g,"")) : Number(valor.replace(/[^0-9]+/g,""));
        }
        
        let allCheck = true;
        checks.forEach((c) => {
            if (!c) allCheck = false
        });

        let tieneAgrupacion = this.state.opcionesRecaudo && this.state.opcionesRecaudo != "" && this.state.opcionesRecaudo.agruparFacturas.activo;
        if (!tieneAgrupacion) {
            checks.map((ch, i) => {
                checks[i] = false;
                return '';
            });
        }
        this.setState({
            allCheck: allCheck,
            checks,
            checksOtroValor,
            checksValor1,
            checksValor2,
            checksValor3,
            valuesOtroValor,
        }, () => {
            this.valorTotal();
            this.validarValoresPagar(valor, key);
            this.validator.showMessages();
        })

    }

    clickCheckOtroValor(e) {
        let key = e.target.value
        // console.log(key, "otro valor")
        let checks = [...this.state.checks];
        let checksOtroValor = [...this.state.checksOtroValor];
        let checksValor1 = [...this.state.checksValor1];
        let checksValor2 = [...this.state.checksValor2];
        let checksValor3 = [...this.state.checksValor3];
        checksOtroValor[key] = !checksOtroValor[key];
        if (checksOtroValor[key]) {
            checks[key] = true;
            checksValor1[key] = false;
            checksValor2[key] = false;
            checksValor3[key] = false;
        } else {
            checks[key] = false;
        }

        let allCheck = true;
        checks.forEach((c) => {
            if (!c) allCheck = false
        })
        let tieneAgrupacion = this.state.opcionesRecaudo && this.state.opcionesRecaudo != "" && this.state.opcionesRecaudo.agruparFacturas.activo;
        if (!tieneAgrupacion) {
            checks.map((ch, i) => {
                checks[i] = false;
                return '';
            });
        }
        this.setState({
            allCheck: allCheck,
            checks,
            checksOtroValor,
            checksValor1,
            checksValor2,
            checksValor3,
        }, () => {
            this.valorTotal();
            if (!this.state.cambiarPantalla && checksOtroValor[key]) this.cambiarPantalla();

        });
    }

    clickCheckValor(valor, position) {
        if(position===1)this.clickCheckValor1(valor)
        if(position===2)this.clickCheckValor2(valor)
        if(position===3)this.clickCheckValor3(valor)
    }

    clickCheckValor1(value) {
        let key = value
        let checks = [...this.state.checks];
        let checksOtroValor = [...this.state.checksOtroValor];
        let checksValor1 = [...this.state.checksValor1];
        let checksValor2 = [...this.state.checksValor2];
        let checksValor3 = [...this.state.checksValor3];
        checksValor1[key] = !checksValor1[key];
        // console.log(key)
        if (checksValor1[key]) {
            checks[key] = true;
            checksOtroValor[key] = false;
            checksValor2[key] = false;
            checksValor3[key] = false;
        } else {
            checks[key] = false;
        }
        let allCheck = true;
        checks.forEach((c) => {
            if (!c) allCheck = false
        })
        let tieneAgrupacion = this.state.opcionesRecaudo && this.state.opcionesRecaudo != "" && this.state.opcionesRecaudo.agruparFacturas.activo;
        // console.log(tieneAgrupacion)
        if (!tieneAgrupacion) {
            checks.map((ch, i) => {
                checks[i] = false;
                return '';
            });
        }
        this.setState({
            allCheck: allCheck,
            checks,
            checksOtroValor,
            checksValor1,
            checksValor2,
            checksValor3,
        }, () => this.valorTotal())
    }

    clickCheckValor2(value) {
        let key = value
        let checks = [...this.state.checks];
        let checksOtroValor = [...this.state.checksOtroValor];
        let checksValor1 = [...this.state.checksValor1];
        let checksValor2 = [...this.state.checksValor2];
        let checksValor3 = [...this.state.checksValor3];
        checksValor2[key] = !checksValor2[key];
        if (checksValor2[key]) {
            checks[key] = true;
            checksValor1[key] = false;
            checksOtroValor[key] = false;
            checksValor3[key] = false;
        } else {
            checks[key] = false;
        }
        let allCheck = true;
        checks.forEach((c) => {
            if (!c) allCheck = false
        })
        let tieneAgrupacion = this.state.opcionesRecaudo && this.state.opcionesRecaudo != "" && this.state.opcionesRecaudo.agruparFacturas.activo;
        if (!tieneAgrupacion) {
            checks.map((ch,i) => {
                checks[i] = false;
                return '';
            });
        }
        this.setState({
            allCheck: allCheck,
            checks,
            checksOtroValor,
            checksValor1,
            checksValor2,
            checksValor3,
        }, () => this.valorTotal())
    }

    clickCheckValor3(value) {

        let key = value
        let checks = [...this.state.checks];
        let checksOtroValor = [...this.state.checksOtroValor];
        let checksValor1 = [...this.state.checksValor1];
        let checksValor2 = [...this.state.checksValor2];
        let checksValor3 = [...this.state.checksValor3];
        checksValor3[key] = !checksValor3[key];
        if (checksValor3[key]) {
            checks[key] = true;
            checksValor1[key] = false;
            checksValor2[key] = false;
            checksOtroValor[key] = false;
        } else {
            checks[key] = false;
        }
        let allCheck = true;
        checks.forEach((c) => {
            if (!c) allCheck = false
        })
        let tieneAgrupacion = this.state.opcionesRecaudo && this.state.opcionesRecaudo != "" && this.state.opcionesRecaudo.agruparFacturas.activo;
        // console.log(tieneAgrupacion)
        if (!tieneAgrupacion) {
            checks.map((ch, i) => {
                checks[i] = false;
                return '';
            });
        }
        this.setState({
            allCheck: allCheck,
            checks,
            checksOtroValor,
            checksValor1,
            checksValor2,
            checksValor3,
        }, () => this.valorTotal())
    }

    render() {
        let facturaSeleccionada= this.state.checks.filter((it)=>{
            return it===true;
        });

        const self = this ;

        return (
            <Elastic
                className={"wc cambio"}
                flex={"0 1 auto"}
                direction={"column"}
                jc={"flex-start"}
            >
                {/*<AlertDialog*/}
                {/*    titulo={'Información de la factura'}*/}
                {/*    icono={'fa fa-info-circle fa-lg'}*/}
                {/*    subtitulo={'Resumen de la factura'}*/}
                {/*    data={this.state.showModal.data}*/}
                {/*    closeModal={this.showModal}*/}
                {/*    visible={this.state.showModal.activo}*/}
                {/*/>*/}

                <Modal
                    tipo={"info"}
                    close={this.showModal}
                    open={this.state.showModal.activo}
                    customMessage={
                        <div className={"wc"}>
                            <div className="p-2 wc text-center">
                                <p className={"mb-0 fs-20"}>Información de la factura</p>
                                <p>Resumen de la factura</p>
                            </div>
                            {
                                this.state.showModal.data.map((item, key) =>{
                                    return (
                                        <div className={'f01 wc py-1'} key={key}>
                                            <div className={'col-md-6 text-left text-color-black'}>
                                                <p className={"mb-0"}><b>{item.llave}:</b></p>
                                            </div>
                                            <div className={'col-md-6 text-right'}>
                                                {
                                                    item.entidad === 'total' || item.entidad === 'segundoTotal' || item.entidad === 'tercerTotal' || item.entidad === 'iva'?
                                                        <><CurrencyFormat value={item.valor} displayType={'text'} thousandSeparator={true} prefix={'$'}/> {this.state.moneda}</>
                                                        :<p className={"mb-0"}>{item.valor}</p>
                                                }
                                            </div>
                                        </div>

                                    )
                                })}
                        </div>
                    }
                >

                </Modal>

                {!this.state.procesando  &&
                <Mycard
                    bgT
                    className={`col-12 mx-auto px-0 ${
                        this.state.opcionesRecaudo.multiplesValoresPago.opcion === "1" ? "col-lg-9 " :
                            this.state.opcionesRecaudo.multiplesValoresPago.opcion === "2" ? "col-lg-10" :
                                this.state.opcionesRecaudo.multiplesValoresPago.opcion === "3" ? "col-lg-11" : ""}`}
                    title={"Listado"}
                    back={ruta.home}
                    visible
                    footer={
                        this.state.opcionesRecaudo!="" && this.state.opcionesRecaudo && this.state.opcionesRecaudo.agruparFacturas.activo && <FooterL
                            loading={this.state.loading}
                            total={this.state.totalPagar}
                            moneda={this.state.moneda}
                            disableButton={this.state.allCheck || (this.state.checks.length>0 && facturaSeleccionada.length>0)}
                            pagarFacturas={()=>this.pagarFacturas()}
                        />
                    }
                    history={this.props.history}
                >

                    <div className="wc px-1 px-md-2">
                        <CustomizedSnackbars
                            message={this.state.showMessage.message}
                            type={'info'}
                            visible={this.state.showMessage.open}
                            isClosed={true}
                            onClose={this.closedAlert}
                        />
                        {
                            this.state.opcionesRecaudo!="" && this.state.opcionesRecaudo && this.state.opcionesRecaudo.agruparFacturas.activo &&
                            <Flex className="wc cb pb-3 pl-3 " jc={"flex-start"}>
                                <Mycheck
                                    // active={this.state.allCheck}
                                    active = {this.state.allCheck || this.state.checks.every(item => item) }
                                    clickCheck={this.onChangeCheck.bind(this)}
                                    all={true}/>
                                <small className={"mb-0 ml-3"}>Seleccionar todas</small>
                            </Flex>
                        }
                        {/*{*/}
                        {/*    this.state.cambiarPantalla*/}
                        {/*        ?(*/}
                        {/*            <AbonoMultiplesValores*/}
                        {/*                clickCheck={this.onChangeCheck.bind(this)}*/}
                        {/*                {...this.state}*/}
                        {/*                onChangeOtroValor={this.onChangeOtroValor.bind(this)}*/}
                        {/*                clickCheckOtroValor={this.clickCheckOtroValor.bind(this)}*/}
                        {/*                salirCambiarPantalla={()=>this.salirCambiarPantalla()}*/}
                        {/*            />*/}
                        {/*        )*/}
                        {/*        :(*/}
                        {/*            <Factura*/}
                        {/*                pagar={this.pagar.bind(this)}*/}
                        {/*                clickCheck={this.onChangeCheck.bind(this)}*/}
                        {/*                loadFunc={this.loadFunc.bind(this)}*/}
                        {/*                {...this.state}*/}
                        {/*                clickCheckOtroValor={this.clickCheckOtroValor.bind(this)}*/}
                        {/*                onChangeOtroValor={this.onChangeOtroValor.bind(this)}*/}
                        {/*                clickCheckValor1={this.clickCheckValor1.bind(this)}*/}
                        {/*                clickCheckValor2={this.clickCheckValor2.bind(this)}*/}
                        {/*                clickCheckValor3={this.clickCheckValor3.bind(this)}*/}
                        {/*                showModal={this.showModal}*/}
                        {/*                validator={this.validator}*/}
                        {/*                opcionesRecadudo={this.state.opcionesRecaudo}*/}
                        {/*            />*/}
                        {/*        )*/}
                        {/*}*/}

                    {this.state.facturas.map((item,index)=>
                        <FacturaComp
                            item={item}
                            key={index}
                            position={index}
                            pagar={()=> this.pagar(index)}
                            clickCheck={this.onChangeCheck.bind(this)}
                            loadFunc={this.loadFunc.bind(this)}
                            {...this.state}
                            clickCheckOtroValor={this.clickCheckOtroValor.bind(this)}
                            onChangeOtroValor={value => this.onChangeOtroValor(value,index)}
                            clickCheckValor={this.clickCheckValor.bind(this)}
                            // clickCheckValor1={this.clickCheckValor1.bind(this)}
                            // clickCheckValor2={this.clickCheckValor2.bind(this)}
                            // clickCheckValor3={this.clickCheckValor3.bind(this)}
                            otherValue={this.state.valuesOtroValor[index]}
                            checked={this.state.checks[index]}
                            value={index}
                            onChange={this.onChangeCheck.bind(this)}
                            showModal={()=>this.showModal(index)}
                            validator={this.validator}
                            opcionesRecadudo={this.state.opcionesRecaudo}
                            numeroFacrtura={ item}
                            min={this.state.minimos.length>0?this.state.minimos[index]:0}
                            max={this.state.maximos.length>0?this.state.maximos[index]:0}
                            viewCheck={this.state.opcionesRecaudo!="" && this.state.opcionesRecaudo && this.state.opcionesRecaudo.agruparFacturas.activo}
                            modificarValor={this.state.opcionesRecaudo!="" && this.state.opcionesRecaudo &&this.state.opcionesRecaudo.modificarValorPagar.activo}
                            tipoModificacion={this.state.opcionesRecaudo!="" && this.state.opcionesRecaudo&&this.state.opcionesRecaudo.modificarValorPagar.activo?this.state.opcionesRecaudo.modificarValorPagar.opcion:"!="}
                            checkOtroValor={this.state.checksOtroValor[index]}
                            pagarDisabled={this.state.invalidos[index] === true}
                            valores={
                                item.filter(ele => ele.entidad !== "facturaId")
                                    .map((x,y) => (
                                    {
                                        nameValue:x.titulo,
                                        value:x.valor,
                                        rawValue:x.valor2,
                                        active:self.state[`checksValor${y+1}`][index],
                                        entidad:x.entidad,

                                        onClick:()=>{
                                            self[`clickCheckValor${y+1}`](index)

                                            // console.log(self.state.checks,"el estado men:::::")
                                        }
                                    }
                                ))
                            }
                        />
                    )}
                    </div>
                </Mycard>
                }
            </Elastic>
        )
    }
}

export default withRouter(ListafacturasOnline);
